export const WITHDRAWAL_ROUTES = {
    lookup: '/withdrawal',
    selection: '/withdrawal/articles',
    success: '/withdrawal/received',
    error: '/withdrawal/error',
};

export const isWithdrawalPath = (pathname: string) =>
    pathname === WITHDRAWAL_ROUTES.lookup || pathname.startsWith(`${WITHDRAWAL_ROUTES.lookup}/`);
